import styled from 'styled-components'
import DarkButton from '../button/DarkButton'
import { desktop, mobile } from '../../styles/media'
import Link from '../router/Link'
import { StyledUnread } from '../general/Unread'

export const PageNavigation = styled.div`
	align-items: center;
	display: flex;

	> * + * {
		margin-left: 0.5rem;
	}

	${props => !props.standalone && `
		padding-bottom: 0.5rem;
		margin-bottom: 0.5rem;
	`}

	${props => props.wrap && `
		flex-wrap: wrap;
		gap: 0.5rem;

		${PageNavigationLink} {
			margin: 0;

			max-width: calc(100vw - 2rem);
			text-overflow: ellipsis;
			overflow: hidden;
		}
	`}

	${props => props.small && `
		${PageNavigationLink} {
			font-size: 0.9rem;
			padding: 0.35rem 0.5rem;
		}
	`}

	${mobile`
		${props => !props.standalone && !props.wrap && `
			overflow-x: auto;
			margin-left: -1rem;
			padding-left: 1rem;
			padding-right: 1rem;
			position: relative;
			width: calc(100% + 2rem);
		`}
	`}

	${DarkButton} {
		height: 36px;
	}
`

export const PageNavigationLink = styled(Link)`
	background: ${props => props.theme.id === 'dark' ? props.theme.backgroundLight : props.theme.backgroundVeryLight};
	border-radius: 5px;
	color: ${props => props.active ? props.theme.white : props.theme.textPrimaryVeryLight};
	font-weight: ${props => props.active ? '600' : '500'};
	padding: 0.5rem 0.75rem;
	position: relative;
	transition: color 0.1s, background 0.1s;
	text-decoration: none;
	white-space: nowrap;

	align-items: center;
	display: flex;

	${props => props.active && `
		background: ${props.color ? props.color : props.theme.primary};

		${StyledUnread} {
			background: rgba(255, 255, 255, 0.5);
			color: rgba(0, 0, 0, 0.5);
		}

		${props.secondary && `
			background: ${props.theme.secondary};
		`}
	`}

	&:last-child {
		margin-right: 0;

		&:after {
			content: "";
			display: block;
			position: absolute;
			right: -1rem;
			width: 1rem;
			height: 1px;
		}
	}

	svg {
		height: 18px;
		width: 18px;

		& + span {
			margin-left: 0.4rem;
		}
	}

	img {
		margin-right: 0.4rem;
		height: 16px;
		width: 16px;
		border-radius: 50%;
	}

	${props => props.right && `
		margin-left: auto;
	`}

	${props => props.empty && `
		opacity: 0.5;
	`}

	${desktop`
		${props => !props.active ? `
			&:hover {
				background: ${props.theme.primaryVeryLightHover};
				color: ${props.theme.textPrimaryVeryLightHover};
			}
		` : `
			&:hover {
				background: ${props.color ? props.color : props.theme.primary};
				color: ${props.theme.white};

				${props.secondary && `
					background: ${props.theme.secondary};
				`}
			}
		`}
	`}
`

export const PageNavigationRight = styled.div`
	margin-left: auto;
	padding-left: 1rem;

	align-items: center;
	display: flex;
`
